// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorContributionTemplate_heading__C3i7X"};